import { render, staticRenderFns } from "./cpview.vue?vue&type=template&id=670c3d22&scoped=true"
import script from "./cpview.vue?vue&type=script&lang=js"
export * from "./cpview.vue?vue&type=script&lang=js"
import style0 from "./cpview.vue?vue&type=style&index=0&id=670c3d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c3d22",
  null
  
)

export default component.exports